import { all, takeEvery, call, put } from "redux-saga/effects";
// import { push } from "react-router-redux";
import * as actionTypes from "../constants/actionTypes";
import * as actions from "../actions";
import axios from "../services";
import { sessionExpiredMsg } from "../constants/constants";

function* applyForhosts(action) {
    try {
        let { contestName } = action.payload;
        let params = action.payload;

        let response = yield axios.post(`users/contest/${encodeURIComponent(contestName)}/enroll-host`, params)
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        if (response.status == 200) {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.data.msg, notifyType: 2, redirectURL: `/profile` }));
        } else if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        yield put(actions.hideAppLoader());
        // if (error.data != undefined && error.data.isVerify == false) {
        // } else {
        // }
    }
}


export default function* rootSaga() {
    yield takeEvery(actionTypes.APPLY_FOR_HOST, applyForhosts);
}